import React, { useState }      from 'react';
import { getContract }          from '../contract';

/* Chart.js */
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const DECIMALS = 100;          // App.js ile tutarlı

/* ---------- Yardımcılar ---------- */
const mean  = (a) => a.reduce((x,y)=>x+y,0)/a.length;
const stdev = (a) => {
  if(a.length<=1) return 0;
  const m = mean(a);
  return Math.sqrt(a.reduce((s,v)=>s+(v-m)**2,0)/(a.length-1));
};

/* ---------- Ana Bileşen ---------- */
export default function AnalysisPanel() {
  const [measureId, setMeasureId] = useState('');
  const [dataPts,   setDataPts]   = useState(null);
  const [unit,      setUnit]      = useState('');
  const [analysis,  setAnalysis]  = useState('Histogram');
  const [loading,   setLoading]   = useState(false);
  const [err,       setErr]       = useState('');

  /* ---- Measurement çek ---- */
  const fetchData = async () => {
    if(!measureId) return;
    try{
      setLoading(true); setErr('');
      const c = getContract();
      const d = await c.getMeasurement(measureId);
      const flat = d[4]
        .map(sg=>sg.map(v=>parseFloat(v.toString())/DECIMALS))
        .flat();
      setDataPts(flat);
      setUnit(d[3]);
    }catch(e){
      console.error(e);
      setErr('Measurement getirilemedi');
      setDataPts(null);
    }finally{
      setLoading(false);
    }
  };

  /* ---- Histogram + Bell Curve çiz ---- */
  const renderHistogram = () => {
    if(!dataPts) return null;
    const k   = Math.ceil(Math.log2(dataPts.length)+1);     // Sturges
    const min = Math.min(...dataPts);
    const max = Math.max(...dataPts);
    const h   = (max-min)/k;
    const bins = Array(k).fill(0);
    dataPts.forEach(v=>{
      const idx = Math.min(k-1, Math.floor((v-min)/h));
      bins[idx] += 1;
    });

    const labels = bins.map((_,i) =>
      `${(min + i*h).toFixed(2)}–${(min + (i+1)*h).toFixed(2)}`
    );

    const mu    = mean(dataPts);
    const sigma = stdev(dataPts);

    // Normal dağılım eğrisi değerleri (frekans ölçekli)
    const densities = labels.map((_, i) => {
      const x = min + (i + 0.5) * h;
      const pdf = (1 / (sigma * Math.sqrt(2 * Math.PI))) *
                  Math.exp(-0.5 * Math.pow((x - mu) / sigma, 2));
      return pdf * dataPts.length * h;  // ölçekleme
    });

    const chartData = {
      labels,
      datasets: [
        {
          type: 'bar',
          label: 'Frekans',
          data: bins,
          backgroundColor: 'rgba(54,162,235,0.6)',
          borderColor: 'rgba(54,162,235,1)',
          borderWidth: 1
        },
        {
          type: 'line',
          label: 'Normal Eğri',
          data: densities,
          fill: false,
          borderColor: 'rgba(255,99,132,1)',
          borderWidth: 2,
          pointRadius: 0,
          tension: 0.4
        }
      ]
    };

    return (
      <>
        <Bar data={chartData} options={{
          scales: {
            y: { title: { display: true, text: 'Frekans' } }
          }
        }}/>
        <div style={{ marginTop: 12 }}>
          <h4>Özet</h4>
          <p>n = {dataPts.length}</p>
          <p>μ = {mu.toFixed(3)} {unit} σ = {sigma.toFixed(3)}</p>
          <p>Min–Max = {min.toFixed(3)} – {max.toFixed(3)}</p>
        </div>
      </>
    );
  };

  return (
    <div className="section">
      <h2>Analiz</h2>

      <div>
        <label>ID:</label>
        <input type="number" value={measureId}
               onChange={e=>setMeasureId(e.target.value)}
               style={{ marginLeft: 10 }}/>
        <button onClick={fetchData} style={{ marginLeft: 10 }}>Getir</button>
      </div>

      {loading && <p>Yükleniyor…</p>}
      {err     && <p style={{ color: 'red' }}>{err}</p>}

      {dataPts && (
        <>
          <div style={{ marginTop: 10 }}>
            <label>Analiz Türü:</label>
            <select value={analysis}
                    onChange={e => setAnalysis(e.target.value)}
                    style={{ marginLeft: 10 }}>
              <option value="Histogram">Histogram</option>
            </select>
          </div>

          {analysis === 'Histogram' && renderHistogram()}
        </>
      )}
    </div>
  );
}